module.exports = __webpack_public_path__ + "img/speed.b2c9c0ef.svg";